// API
import { api } from './api';

// Types
import { FetchResponseType } from '../../types/Fetch';

/**
 * Special fetch method for GET leads for views list by sending query parameters
 *
 * @param params LeadsCallQueryParamsType
 * @param headers
 * @returns Promise<FetchResponseType>
 */
export default async function fetchWorkflowTask(leadId: string, token: string): Promise<FetchResponseType> {
    let _url = api.workflowTask.replace(/:leadId/, leadId);

    const resp = await fetch(_url, {
        method: 'GET',
        headers: {
            'Accept-Language': 'de-DE',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
    });

    return {
        data: resp.status === 200 ? resp.json() : undefined,
        status: resp.status,
        error: resp.status === 200 ? undefined : resp,
    };
}
